import generateUtilityClasses from "../../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
import generateUtilityClass from "../../../utils/generateUtilityClass/generateUtilityClass.es.js";
function getPickersInputBaseUtilityClass(slot) {
  return generateUtilityClass("MuiPickersInputBase", slot);
}
const pickersInputBaseClasses = generateUtilityClasses("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);
export {
  getPickersInputBaseUtilityClass,
  pickersInputBaseClasses
};
//# sourceMappingURL=pickersInputBaseClasses.es.js.map
